"use client"

import { Skeleton } from "@rarible_int/anaconda_ui_components"
import type React from "react"

interface Props {
  heading: React.ReactNode
  actions: React.ReactNode
  title: React.ReactNode
  subtitle: React.ReactNode
}

export function ItemInfoSection(props: Props) {
  return <ItemInfoSectionContent {...props} />
}

function ItemInfoSectionContent(props: Props) {
  const { heading, actions, title, subtitle } = props

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-between gap-1">
        <div>{heading}</div>
        <div className="flex items-center gap-[10px]">{actions}</div>
      </div>
      <h3 className="text-2xl">{title}</h3>
      {subtitle}
    </div>
  )
}

export function ItemInfoSkeleton() {
  return (
    <div className="flex flex-col gap-2">
      <Skeleton className="h-9 w-[250px]" />
      <Skeleton className="h-9 w-[150px]" />
      <Skeleton className="h-7 w-[240px]" />
    </div>
  )
}
